<div *ngIf="valider == false" id="devisModal">
  <div class="modal-content">
    <div class="modalContainer">
      <form action="">
        <div class="cardModalTitle">
          <h4>Demandez un devis</h4>
          <span class="close" (click)="closeModals()">
            <img src="assets/img/close-white.svg" alt="" />
          </span>
        </div>
        <div class="cardModalContent">
          <p>
            Nous allons vous envoyer un devis personnalisé à l'adresse suivante
            :
          </p>

          <input
            #inputEmail="ngModel"
            type="email"
            class="modalMailInput"
            name="inputEmail"
            id=""
            [(ngModel)]="data.email"
            [required]="true"
            email
            pattern="[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$"
          />

          <div
            *ngIf="
              (inputEmail.invalid && inputEmail.dirty) ||
              invalidEmail(data.email)
            "
            class="alert alert-danger"
          >
            Veuillez renseigner une adresse mail valide.
          </div>

          <p class="autreDemandeDevis">
            Vous pouvez aussi souscrire par téléphone au
            <span>{{ number_phone }}</span>
            (prix d'un appel normal) <br />
            Du lundi au vendredi de 9h à 19h.
          </p>
          <button
            [disabled]="
              (inputEmail.invalid && inputEmail.dirty) ||
              invalidEmail(data.email)
            "
            (click)="validateDemandeDevis()"
            class="modalButton vmBValider"
          >
            <div class="modalButtoncontent">
              <div
                *ngIf="isUpdating"
                class="spinner-border text-light"
                role="status"
              >
                <span class="sr-only">Traitement...</span>
              </div>
              <span>Valider</span>
            </div>
          </button>
        </div>
      </form>
    </div>
  </div>
</div>

<div *ngIf="valider == true" id="devisCheckModal">
  <div class="modal-content">
    <span class="close closeModal2" (click)="closeModals()">
      <img src="assets/img/close.svg" alt="" />
    </span>
    <div class="modalContainer">
      <img src="assets/img/mailSend.svg" id="avatar" alt="" />

      <form action="">
        <p>
          C’est envoyé ! Vous allez recevoir votre devis par email
          <br class="breakLine" />
          dans quelques instants.
        </p>
        <div class="recapOffre">
          <div class="recapImage">
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'CEGEMAEss'"
              src="assets/img/essentiel2.svg"
              alt=""
            />
            <img
              *ngIf="
                data.tarif.produitTarif ==
                  'MEILLEURTAUX_VITA_SANTE_55_PLUS_NR' ||
                data.tarif.produitTarif ==
                  'MEILLEURTAUX_VITA_SANTE_55_PLUS_ECO_NR'
              "
              class="scaleImg"
              src="assets/img/mtx_vita_sante_plus55.svg"
              alt=""
              style="width: 90%"
            />
            <img
              *ngIf="
                data.tarif.produitTarif ==
                  'MEILLEURTAUX_VITA_SANTE_FAMILLE_ECO_NR' ||
                data.tarif.produitTarif == 'MEILLEURTAUX_VITA_SANTE_FAMILLE_NR'
              "
              class="scaleImg"
              src="assets/img/mtx_vita_sante_famille.svg"
              alt=""
              style="width: 90%"
            />
            <img
              class="scaleImg"
              *ngIf="
                data.tarif.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE_ECO' ||
                data.tarif.produitTarif == 'PREVOIR_IMM_SANTE_FAMILLE'
              "
              src="assets/img/100FamilleSante.svg"
              style="width: 90%"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="
                data.tarif.produitTarif == 'AESIO_IMM_SANTE_FAMILLE_ECO' ||
                data.tarif.produitTarif == 'AESIO_IMM_SANTE_FAMILLE'
              "
              src="assets/img/100FamilleSante.svg"
              style="width: 90%"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'RELAXEO2'"
              src="assets/img/Relaxeo.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'PARTICULIER'"
              src="assets/img/SLPart.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'SWLF_RETRAITES'"
              src="assets/img/SLSenior.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'PROGR_SANTE_FAMILLE'"
              src="assets/img/prog_sante_famille.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'PROGR_SANTE_SENIOR'"
              src="assets/img/prog_sante_senior.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'CEGEMAV'"
              src="assets/img/vitaneor.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'CEGE_EQUILIBRE'"
              src="assets/img/cegema-flexibilite.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="
                data.tarif.produitTarif ==
                  'CEGEMA_FLEXI_SANTE_NON_RESPONSABLE' ||
                data.tarif.produitTarif == 'CEGEMA_FLEXI_SANTE_RESPONSABLE'
              "
              src="assets/img/cegema-flexibilite.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="
                data.tarif.produitTarif == 'KEREIS_SERENITE'
              "
              src="assets/img/cegema-serenite-sante.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'AC_PRIVILEGE'"
              src="assets/img/OptimumSante.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="
                data.tarif.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR_ECO' ||
                data.tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR_ECO'
              "
              src="assets/img/aesio_imm_senior_eco.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="
                data.tarif.produitTarif == 'PREVOIR_IMM_SANTE_SENIOR' ||
                data.tarif.produitTarif == 'AESIO_IMM_SANTE_SENIOR'
              "
              src="assets/img/aesio_imm_senior.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'ESS_SANTE_SENIOR'"
              src="assets/img/Essentiel_Sante_Senior.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'ESS_SANTE_FAMILLE'"
              src="assets/img/Essentiel_Sante_Famille.svg"
              alt=""
            />

            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'VITAMIN3'"
              src="assets/img/Vitamin3.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'ZEN_SANTE_FAMILLE'"
              src="../../../../../../assets/img/Zenioo_Sante_Famille.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'ZEN_SANTE_55_PLUS'"
              src="../../../../../../assets/img/Zenioo_Sante_55Plus.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'ZEN_SANTE_SENIOR'"
              src="../../../../../../assets/img/Zenioo_Sante_Senior.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'ZEN_SANTE_SENIOR_ECO'"
              src="../../../../../../assets/img/Zenioo_Sante_Senior_Eco.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'SANTE_MALIN'"
              src="../../../../../../assets/img/spvie_sante_malin.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'SPVIE_GENIUS_ESSENTIELLE'"
              src="../../../../../../assets/img/spvie_sante_essentielle.svg"
              alt=""
            />
            <img
              class="scaleImg"
              *ngIf="data.tarif.produitTarif == 'SPVIE_SANTE_NOVA_NR'"
              src="../../../../../../assets/img/spvie_sante_nova_nr.svg"
              alt=""
            />
          </div>
          <div class="recapPrix">
            <div class="mensuel">
              <span class="prix">{{
                (ate(data.tarif.montant) | number: '1.1-2')?.split('.')?.[0] ||
                  '0'
              }}</span>
              ,{{
                (ate(data.tarif.montant) | number: '1.1-2')?.split('.')?.[1] ||
                  '00'
              }}€/mois
            </div>
            <div class="annuel">
              Soit
              {{ ate(data.tarif.montant) * 12 | number: '1.1-2' : 'fr' }}€/an
              tout inclus
            </div>
          </div>
        </div>
        <div class="dossierRef">
          Référence du dossier : <span>{{ quotationForm.vadInfo.leadId }}</span>
        </div>
        <p class="autreDemandeDevis">
          Vous pouvez aussi souscrire par téléphone au
          <span>{{ number_phone }}</span>
          (prix d'un appel normal) <br />
          Du lundi au vendredi de 9h à 19h.
        </p>
        <input
          type="button"
          value="Retour à la liste des offres"
          class="modalButton"
          [mat-dialog-close]="data.email"
          cdkFocusInitial
        />
      </form>
    </div>
  </div>
</div>
